var _excluded = ["label", "id", "name", "type"];

function _extends() {
  _extends = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

import React from "react";
import { StyledInput, StyledLabel, StyledRadioButton } from "./styles";
export var RoundCheckBox = function RoundCheckBox(_ref) {
  var label = _ref.label,
    id = _ref.id,
    name = _ref.name,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "radio" : _ref$type,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    /*#__PURE__*/ React.createElement(
      StyledInput,
      _extends(
        {
          type: type,
          name: name,
          id: id,
        },
        rest
      )
    ),
    /*#__PURE__*/ React.createElement(
      StyledLabel,
      {
        htmlFor: id,
      },
      /*#__PURE__*/ React.createElement(StyledRadioButton, null),
      " ",
      label
    )
  );
};
